import { gql } from 'apollo-angular'

export const GET_MAGAZINE_FILTER_ITEMS = gql`
  query getMagazineFilterItems {
    Magazines(select: true, limit: -1, where: { published: { equals: true } }) {
      docs {
        id
        title
      }
    }
  }
`
